import { useEffect, useState } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { authApi } from './api'
import Layout from './components/Layout'
import ToastContainer from './components/ToastContainer'
import Dashboard from './pages/Dashboard'
import AdvancedPreview from './pages/AdvancedPreview'
import LandingPage from './pages/LandingPage'
import LegalPage from './pages/LegalPage'
import Preview from './pages/Preview'
import Processing from './pages/Processing'
import Settings from './pages/Settings'
import { useAuthStore } from './store'

function Protected({ children }: { children: JSX.Element }) {
  const { user, setUser } = useAuthStore()
  const [loading, setLoading] = useState(!user)

  useEffect(() => {
    if (user) return
    authApi.me()
      .then((res) => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false))
  }, [user, setUser])

  if (loading) return <div className="min-h-screen grid place-items-center text-gray-600">Loading...</div>
  if (!user) return <Navigate to="/" replace />
  return children
}

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/terms-of-service" element={<LegalPage type="terms" />} />
        <Route path="/privacy-policy" element={<LegalPage type="privacy" />} />
        <Route path="/refund-policy" element={<LegalPage type="refund" />} />
        <Route path="/dashboard" element={<Protected><Layout><Dashboard /></Layout></Protected>} />
        <Route path="/documents/:documentId/process" element={<Protected><Layout><Processing /></Layout></Protected>} />
        <Route path="/documents/:documentId/preview" element={<Protected><Layout><Preview /></Layout></Protected>} />
        <Route path="/documents/:documentId/advanced-preview" element={<Protected><Layout><AdvancedPreview /></Layout></Protected>} />
        <Route path="/process/:documentId" element={<LegacyProcessRedirect />} />
        <Route path="/settings" element={<Protected><Layout><Settings /></Layout></Protected>} />
      </Routes>
      <ToastContainer />
    </>
  )
}

function LegacyProcessRedirect() {
  const { documentId } = useParams()
  return <Navigate to={`/documents/${documentId}/process`} replace />
}

export default App
